import axios from 'axios';
import CONFIG from '@/config';
import { ElMessage } from 'element-plus';
import router from '@/router';
import { useUserStore } from '@/stores/userStore';

// 创建 axios 实例
const instance = axios.create({
  baseURL: CONFIG.API_BASE_URL,
  timeout: 60000, // 增加超时时间到60秒，以适应语音合成等耗时操作
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
instance.interceptors.request.use(config => {
  // 添加认证令牌等
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // 如果是 FormData，删除 Content-Type 让浏览器自动设置
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  
  return config;
}, error => {
  return Promise.reject(error);
});

// 响应拦截器
instance.interceptors.response.use(response => {
  
  // 处理响应数据 - 正确访问 response.data
  if (response.data && response.data.code === 200) {
    return response.data;
  } else {
    // 处理 HTTP 200 但业务逻辑错误的情况
    const errorMsg = response.data?.message || '请求成功但业务处理失败';
    return Promise.reject(new Error(errorMsg));
  }
}, async error => {
  console.log('响应拦截器捕获到错误:', error);
  
  // 处理错误响应
  if (error.response) {
    const { status, data, headers } = error.response;
    console.log('错误响应状态:', status);
    console.log('错误响应数据:', data);
    console.log('错误响应头:', headers);
    
    let message = '请求失败';
    
    if (status === 401) {
      message = '未授权，请登录';
      // 清除本地token并跳转到登录页
      localStorage.removeItem('token');
      const userStore = useUserStore();
      userStore.logout();
      // 延迟跳转，确保消息能显示
      await ElMessage.error(message);
      console.log('401错误：已清除token并调用logout，即将跳转到登录页');
      router.push('/login');
    } else if (status === 403) {
      message = '拒绝访问，登录已失效';
      console.log('处理403错误，清除token并跳转到登录页');
      // 清除本地token并跳转到登录页
      localStorage.removeItem('token');
      const userStore = useUserStore();
      userStore.logout();
      // 延迟跳转，确保消息能显示
      await ElMessage.error(message);
      console.log('403错误：已清除token并调用logout，即将跳转到登录页');
      router.push('/login');
    } else if (status === 404) {
      message = '资源不存在';
      ElMessage.error(message);
    } else if (data && data.message) {
      message = data.message;
      ElMessage.error(message);
    } else {
      ElMessage.error(message);
    }
    
    return Promise.reject(new Error(message));
  } else if (error.request) {
    console.log('无响应错误:', error.request);
    const message = '无响应，请检查网络';
    ElMessage.error(message);
    return Promise.reject(new Error(message));
  } else {
    console.log('请求配置错误:', error.message);
    const message = '请求配置错误';
    ElMessage.error(message);
    return Promise.reject(new Error(message));
  }
});

// 导出 request 方法
export const request = instance;